const gupioLogo = "/branding/gupio-logo.png";

const footerLinks = [
  {
    iconSrc: "/social/website.svg",
    href: "https://www.gupio.in/",
    label: "Website"
  },
  {
    iconSrc: "/social/instagram.svg",
    href: "https://www.instagram.com/gupio.in/",
    label: "Instagram"
  },
  {
    iconSrc: "/social/linkedin.svg",
    href: "https://www.linkedin.com/company/gupio-services-private-limited/",
    label: "LinkedIn"
  },
  {
    iconSrc: "/social/youtube.svg",
    href: "https://www.youtube.com/@GupioService",
    label: "YouTube"
  }
];

export function Footer() {
  return (
    <footer className="border-t border-line/90 bg-[linear-gradient(180deg,#ffffff_0%,#fbfcff_100%)]">
      <div className="px-6 py-10 lg:px-8">
        <div className="grid gap-8 rounded-[28px] border border-line/70 bg-white/88 px-6 py-7 shadow-[0_16px_40px_rgba(15,23,42,0.04)] md:grid-cols-[minmax(0,1.25fr)_minmax(280px,0.75fr)] md:px-8">
          <div className="min-w-0">
            <img alt="Gupio" className="h-12 w-auto object-contain" src={gupioLogo} />
            <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate/80">
              Legal Agreement Portal
            </p>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-slate">
              A structured portal for candidate verification, agreement execution, and governed administrative review.
            </p>

            <div className="mt-6 grid gap-2 text-sm text-slate">
              <p className="font-semibold text-ink">Gupio Services Private Limited</p>
              <p className="text-slate/80">Official onboarding communication and agreement execution portal.</p>
            </div>
          </div>

          <div className="md:justify-self-end">
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate/80">
              Official Links
            </p>
            <div className="mt-4 grid gap-3 sm:grid-cols-2" aria-label="Gupio links">
              {footerLinks.map(({ href, iconSrc, label }) => (
                <a
                  className="group inline-flex items-center justify-between gap-3 rounded-[18px] border border-line/80 bg-white px-4 py-3 text-sm font-semibold text-slate shadow-sm transition hover:-translate-y-0.5 hover:border-royal/25 hover:text-royal hover:shadow-[0_14px_28px_rgba(17,24,39,0.08)] focus:outline-none focus-visible:ring-4 focus-visible:ring-royal/10"
                  href={href}
                  key={label}
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="inline-flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-2xl border border-line/70 bg-cloud/60 transition group-hover:bg-royal/10">
                      <img
                        alt={label}
                        className="h-5 w-5 select-none"
                        decoding="async"
                        loading="lazy"
                        src={iconSrc}
                      />
                    </span>
                    <span>{label}</span>
                  </span>
                  <span className="text-xs font-semibold text-slate/60 group-hover:text-royal/70">
                    Visit
                  </span>
                </a>
              ))}
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-slate md:text-right">
              Intended for official onboarding communication, document review, and candidate portal access.
            </p>
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-2 text-xs text-slate/75 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Gupio Services Private Limited. All rights reserved.</p>
          <p>Secure onboarding and agreement management workspace.</p>
        </div>
      </div>
    </footer>
  );
}
